import React from 'react'
import styled from 'styled-components'

import { useAppErrorState } from '@contexts/AppError'

const H1 = styled.h1`
  text-align: center;
`

/**
 * handle an App-level error. Tell the user application is offline and to try
 * again later.
 */
const AppError: React.FC = ({ children }) => {
  const appErrorState = useAppErrorState()

  if (appErrorState) {
    return (
      <H1>
        We&rsquo;re sorry, something went wrong. Please try to log in again
        later.
      </H1>
    )
  }

  return <>{children}</>
}

export default AppError
